import { Alert } from '@salecycle/ui-component-library';
import { useCampaignEditorContext } from '../state/hooks/useCampaignEditorContext';
import { useTranslation } from 'react-i18next';
import { formatSendDate } from '../utils/formatSendDate';
import { OffsiteCampaignStatus } from 'models/offsite/Campaign/LifeCycle';

export const CampaignNotice = () => {
  const { t } = useTranslation('campaigns');
  const { state } = useCampaignEditorContext();

  switch (state.status) {
    case OffsiteCampaignStatus.Scheduled:
      return (
        <Alert
          variant="info"
          heading={t('bulkRetargetingCampaigns.editor.notice.scheduled.heading')}
          style={{ minHeight: 128, height: 128 }}
        >
          <p>
            {state.campaign.sendDate
              ? t('bulkRetargetingCampaigns.editor.notice.scheduled.dateBody', {
                  date: formatSendDate(state.campaign.sendDate),
                })
              : t('bulkRetargetingCampaigns.editor.notice.scheduled.immediateBody')}
          </p>
        </Alert>
      );

    case OffsiteCampaignStatus.Triggered:
      return (
        <Alert
          variant="info"
          heading={t('bulkRetargetingCampaigns.editor.notice.triggered.heading')}
          style={{ minHeight: 104, height: 104 }}
        >
          <p>{t('bulkRetargetingCampaigns.editor.notice.triggered.body')}</p>
        </Alert>
      );

    default:
      return null;
  }
};
